import { Rate } from './../Rate/Rate.model';
import { DisneyMealPlan } from '../DisneyMealPlan/DisneyMealPlan.model';
import { Room } from '../Room/Room.model';
import { IPrepaidroomcluster } from './IPrepaidRoomCluster';

export class PrepaidRoomCluster implements IPrepaidroomcluster {
  rooms: Room[];
  disney_meal_plans: DisneyMealPlan[];
  offerCodes: string[];
  rates: Rate[];
  prioritized_by_rate_filter: boolean;

  constructor(data: PrepaidRoomCluster) {
    this.rooms = data.rooms as Room[];
    this.disney_meal_plans = data.disney_meal_plans as DisneyMealPlan[];
    this.offerCodes = data.offerCodes;
    this.rates = data.rates;
    this.prioritized_by_rate_filter = data.prioritized_by_rate_filter || false;
  }
}
